import React from "react";

const VideoInteractivity = (props) => {
  if (props.markerInfo.data.video_type === "youtube") {
    return (
      <iframe
        title={props.markerInfo.data.link}
        width="100%"
        height="100%"
        src={
          "https://www.youtube.com/embed/" +
          props.markerInfo.data.link +
          "?autoplay=1&mute=1"
        }
      />
    );
  }
  return (
    <div id="videoIper" style={{ height: "100%" }}>
      <video
        autoPlay="autolplay"
        defaultmuted="true"
        muted
        playsInline
        loop
        style={{ width: "100%" }}
      >
        <source src={props.markerInfo.data.link} />
      </video>
    </div>
  );
};

export default VideoInteractivity;
